import React, { useContext, useEffect, useState } from 'react';
import { Grid, Typography, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../Helpers/Contexts/authContext';
import { AuthUser } from '../../../interfaces/Contexts';
import { getallGroup } from '../../../Utils/apiService';
import routes from '../../../Utils/routes';
import CreatedGroupCard from '../../Groups/components/CreatedGroupCard.tsx';
import AddIcon from '@mui/icons-material/Add';
import Images from '../../../Assets/assetHelper';

const GroupsContent: React.FC = () => {
  const navigate = useNavigate();
  const {
    state: { user }
  } = useContext(AuthContext);
  const userData = user as AuthUser;
  const [createdGroups, setCreatedGroups] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getallGroup(userData?.applicantId)
      .then((res) => {
        const members = [
          { name: 'John Doe', imageUrl: Images.Images.DefaultProfileImage },
          { name: 'Jane Smith', imageUrl: Images.Images.DefaultProfileImage },
          { name: 'Alex Johnson', imageUrl: Images.Images.DefaultProfileImage },
        ];

        const createdGroupsData = res?.data?.data?.createdGroups?.map((group: any) => ({
          groupName: group.Title__c,
          memberCount: group.Member_Count__c,
          members: members,
          id: group.Id,
          contactId: group.Contact__c,
          type: group.Type__c,
          createdDate: group.CreatedDate,
          coverImage: group.Cover_Image_Url__c,
          Location__c: group.Location__c,
          tags: group.Tags__c,
          Description__c: group.Description__c,
          status:group.Approval_Status__c,
        })) || [];

        setCreatedGroups(createdGroupsData);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, [userData?.applicantId]);

  const handleCreateGroup = () => {
    navigate(routes.createGroup);
  };

  const handleViewMore = () => {
    navigate(routes.yourGroups);
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <Typography>Loading...</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2 }}>
      {createdGroups.length > 0 ? (
        <>
          <Grid container spacing={2}>
            {createdGroups.slice(0, 6).map((group: any, index: number) => (
              <Grid key={index} item xs={12} sm={6} md={4}>
                <CreatedGroupCard {...group} fromProfile={true} />
              </Grid>
            ))}
          </Grid>
          {createdGroups.length > 6 && (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
              <Button
                variant="outlined"
                onClick={handleViewMore}
                sx={{
                  borderRadius: '6px',
                  textTransform: 'none',
                  fontSize: '12px',
                  fontWeight: 500
                }}
              >
                View More
              </Button>
            </Box>
          )}
        </>
      ) : (
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          py: 4,
          textAlign: 'center'
        }}>
          <img
            src={Images.Images.NoDataTheme}
            alt="No Groups"
            style={{ width: '100px', height: '100px', marginBottom: '16px' }}
          />
          <Typography variant="body1" sx={{ mb: 2, color: '#666' }}>
            You haven't created any groups yet
          </Typography>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleCreateGroup}
            sx={{
              borderRadius: '6px',
              textTransform: 'none',
              fontSize: '12px',
              fontWeight: 500
            }}
          >
            Create Your First Group
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default GroupsContent;
